const UserCreateAccountSelectManager = {
  'pages_user_components_CustomerInfoChangePassword.title': '비밀번호 변경',
  'pages_user_components_CustomerInfoChangePassword.1': '현재 비밀번호',
  'pages_user_components_CustomerInfoChangePassword.2': '새 비밀번호',
  'pages_user_components_CustomerInfoChangePassword.3': '새 비밀번호 확인',
  'pages_user_components_CustomerInfoChangePassword.miss_match': '비밀번호가 일치하지 않습니다.',
  'pages_user_components_CustomerInfoChangePassword.modify_password': '비밀번호가 수정되었습니다.',
  'pages_user_components_CustomerInfoChangePassword.error_1': '현재 비밀번호를 확인해주세요.',
  'pages_user_components_CustomerInfoChangePassword.error_2': '새 비밀번호를 확인해주세요.',
  'pages_user_components_CustomerInfoChangePassword.error_3': '현재 또는 이전 비밀번호와 동일한 비밀번호를 사용할 수 없습니다.',
  'pages_user_components_CustomerInfoChangePassword.error_4': '아이디와 동일한 비밀번호를 사용할 수 없습니다.'
}

export default UserCreateAccountSelectManager



// WEBPACK FOOTER //
// ./src/lang/user/components/CustomerInfoChangePassword.kr.js